
import './pageInfo.css'
import {useParams} from "react-router-dom";
import MenuSimple from "../ui/menuSimple";
import Footer from "../ui/footer";

const PageInfo = ({info})=>{

    const {id} = useParams()
    console.log(id)
    return(
        <>
            <MenuSimple />
            {/* eslint-disable-next-line array-callback-return */}
            {info.map((item, index) => {
                if(index === Number(id)){
                    console.log(id)
                    return(
                        <>
                            <main className="page-father">
                                <div className={`page-main ${item.side}`}>
                                    <div className="image-page">
                                        <img src={item.image} alt=""/>
                                    </div>
                                    <div className="info-page">
                                        {item.text}
                                    </div>
                                </div>
                            </main>
                            <Footer />
                        </>
                    )
                }
            } )}


        </>
    )
}

export default PageInfo;